import { t as AitisalSdk } from "../../aitisal-sdk-B2mK3RTK.mjs";

//#region restaurant/menu/customization.ts
async function createCustomization(brandUUID, createCustomization) {
	return AitisalSdk.getInstance().post(`brands/${brandUUID}/customizations`, createCustomization);
}
async function updateCustomization(brandUUID, customizationUUID, updateCustomization) {
	return AitisalSdk.getInstance().patch(`brands/${brandUUID}/customizations/${customizationUUID}`, updateCustomization);
}
async function deleteCustomization(brandUUID, customizationUUID) {
	return AitisalSdk.getInstance().delete(`brands/${brandUUID}/customizations/${customizationUUID}`);
}
async function browseCustomizations(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/customizations`);
}

//#endregion
//#region restaurant/menu/item.ts
async function createItem(brandUUID, createItem) {
	return AitisalSdk.getInstance().post(`brands/${brandUUID}/items`, createItem);
}
async function updateItem(brandUUID, itemUUID, updateItem) {
	return AitisalSdk.getInstance().patch(`brands/${brandUUID}/items/${itemUUID}`, updateItem);
}
async function deleteItem(brandUUID, itemUUID) {
	return AitisalSdk.getInstance().delete(`brands/${brandUUID}/items/${itemUUID}`);
}
async function getItemStockSummary(brandUUID, itemUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/items/${itemUUID}/stock-summary`);
}
async function browseItems(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/items`);
}
async function getItemImagePresignedURL(brandUUID, getImageUploadURLRequest) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/items/presigned-url`, { params: { ...getImageUploadURLRequest } });
}
async function toggleItemEnabled(brandUUID, itemUUID, enabled) {
	return AitisalSdk.getInstance().patch(`brands/${brandUUID}/items/${itemUUID}`, { enabled });
}
async function bulkUpsertItemPublishOverrides(brandUUID, itemUUID, upsertItemPublishOverrides) {
	return AitisalSdk.getInstance().put(`brands/${brandUUID}/items/${itemUUID}/publish-overrides`, upsertItemPublishOverrides);
}
async function getItemPublishOverrides(brandUUID, itemUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/items/${itemUUID}/publish-overrides`);
}

//#endregion
//#region restaurant/menu/menu.ts
async function createMenu(brandUUID, createMenu) {
	return AitisalSdk.getInstance().post(`brands/${brandUUID}/menus`, createMenu);
}
async function updateMenu(brandUUID, menuUUID, updateMenu) {
	return AitisalSdk.getInstance().patch(`brands/${brandUUID}/menus/${menuUUID}`, updateMenu);
}
async function deleteMenu(brandUUID, menuUUID) {
	return AitisalSdk.getInstance().delete(`brands/${brandUUID}/menus/${menuUUID}`);
}
async function browseMenus(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/menus`);
}
async function getMenuAggregate(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/menu/cached`);
}
async function getMenuAggregateForVendor(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/menu/vendor`);
}
async function getPopularItems(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/menu/popular`);
}
async function deleteMenuAggregate(brandUUID, menuUUID) {
	return AitisalSdk.getInstance().delete(`brands/${brandUUID}/menus/${menuUUID}/aggregate`);
}

//#endregion
//#region restaurant/menu/section.ts
async function createSection(brandUUID, createSection) {
	return AitisalSdk.getInstance().post(`brands/${brandUUID}/sections`, createSection);
}
async function updateSection(brandUUID, sectionUUID, updateSection) {
	return AitisalSdk.getInstance().patch(`brands/${brandUUID}/sections/${sectionUUID}`, updateSection);
}
async function deleteSection(brandUUID, sectionUUID) {
	return AitisalSdk.getInstance().delete(`brands/${brandUUID}/sections/${sectionUUID}`);
}
async function browseSections(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/sections`);
}
async function getSectionImagePresignedURL(brandUUID, getImageUploadURLRequest) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/sections/presigned-url`, { params: { ...getImageUploadURLRequest } });
}

//#endregion
export { browseCustomizations, browseItems, browseMenus, browseSections, bulkUpsertItemPublishOverrides, createCustomization, createItem, createMenu, createSection, deleteCustomization, deleteItem, deleteMenu, deleteMenuAggregate, deleteSection, getItemImagePresignedURL, getItemPublishOverrides, getItemStockSummary, getMenuAggregate, getMenuAggregateForVendor, getPopularItems, getSectionImagePresignedURL, toggleItemEnabled, updateCustomization, updateItem, updateMenu, updateSection };
//# sourceMappingURL=index.mjs.map